<template>
  <WebinarExplainDialog
    :class="{'opc-modal-dialog': isLegacyModalUI}"
    :show-close="!isLegacyModalUI"
    :visible="visible"
    @close="closeDialog">
    <template v-if="isLegacyModalUI" #back>
      <NavBack :backHandler="closeDialog" class="mb24" />
    </template>
  </WebinarExplainDialog>
</template>

<script>
import NavBack from '@/components/nav-back.vue';
import { showModalDialogCloseButton, hideModalDialogCloseButton } from '@/utils/modal-utils.js';

export default {
  name: 'WebinarExplainDiffDialog',
  components: { NavBack },
  props: {
    visible: Boolean,
  },
  watch: {
    visible(val) {
      if (this.$context?.is?.modal2Column) {
        val ? hideModalDialogCloseButton() : showModalDialogCloseButton();
      }
    }
  },
  computed: {
    isLegacyModalUI() {
      return this.$context?.is?.modal && !this.$context?.is?.modal2Column;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import "@/styles/modal.scss";

.opc-modal-dialog {
  &.webinar-explain-dialog {
    .webinar-explain-dialog_title {
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%; /* 28.8px */
      padding: 24px 0px 4px 0px !important;
      margin-bottom: 0px !important;
    }

    .zbo-dialog {
      .zbo-dialog__header {
        padding: 0px;
      }
    }
  }
}
</style>
